<template>
  <span v-if="variant === 'icon'" class="status-icon" :style="{ backgroundColor: meta.color }" :title="meta.label"></span>
  <span v-else class="status-label" :style="{ color: meta.color }">{{ meta.label }}</span>
</template>

<script>
import { statusMeta } from "./statusMeta";

export default {
  name: "SettlementStatusBadge",
  props: {
    status: { type: String, default: "NIEROZLICZONO" },
    variant: { type: String, default: "label" },
  },
  computed: {
    meta() {
      return statusMeta(this.status);
    },
  },
};
</script>

<style scoped>
.status-label {
  font-weight: 700;
  /* Dziedziczy rozmiar z kontekstu: duży w panelu karty opiekuna (jak w Canvie,
     równy etykiecie), mały w tabelach Raportów/podopiecznego. */
  font-size: inherit;
  text-transform: uppercase;
  white-space: nowrap;
}
.status-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
</style>
